import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import UseGetMeetinInfo from '../hooks/useGetMeetingInfo';
export default function MeetingRoom() {
  const location = useLocation();
  const navigate = useNavigate();
  const parsed = queryString.parse(location.search);
  console.log('parsed:', parsed);
  const meetingInfo = UseGetMeetinInfo(parsed?.room)?.data?.data;

  useEffect(() => {
    if (meetingInfo?.meeting_status !== 'in_progress') {
      navigate(-1);
    }
  }, [navigate, meetingInfo?.meeting_status]);

  return (
    <div className='bg-gray-50 min-h-85vh flex items-center justify-center w-full max-w-main-page mx-auto'>
      <div className='flex mx-10 w-full justify-center'>
        <p className='text-gray-700'>
          Meetings are currently disabled in this build.
        </p>
      </div>
    </div>
  );
}
